import React, { useState } from "react";
import { useSelector } from "types/store";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { ChartsDisplay } from "components/ChatGPT/ChatGPT";
import MarkdownTypewriter from "aible/MarkdownTypewriter/MarkdownTypewriter";
import { CHAT_MARKDOWN_OVERRIDES } from "containers/ChatGPT/reducer";
import styles from "./style.module.css";
import CreateClawFromChat from "components/Templates/CreateClawFromChat";
import { isEnabled } from "@/utils/featureFlags";
const CapabilityItem = ({ type, index, active, currentViewMessage, showCharts, showMessages, showAccordion, showCreateClaw, onClick }) => {
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const agentStepMesssages = useSelector((state) => chatGPTReducer.getAgentStepMessages(state)) ?? {};
    const simpleFlowStep = useSelector((state) => nextReducer.getSimpleFlowStep(state, nextId));
    const [exploreState, updateExploreState] = useState("CHARTS");
    const stepMessages = agentStepMesssages?.[type?.id] ?? {};
    const stepMessagesArr = Object.keys(stepMessages)
        ?.map((mKey) => stepMessages?.[Number(mKey)])
        ?.filter((message) => message !== undefined && message !== null);
    const hasMessages = stepMessagesArr?.length > 0;
    const isCreateClaw = showCreateClaw && type?.id === "CREATE_CLAW" && isEnabled("chat-aible-agent-c");
    return (React.createElement("div", { className: styles.capabilityItemWrapper + " " + (active ? styles.active : "") + " " + (onClick ? styles.hasClick : ""), onClick: onClick },
        React.createElement("div", { className: styles.capabilityHeader },
            React.createElement("div", { className: styles.capabilityIconWrapper },
                React.createElement("img", { className: styles.capabilityIcon, src: active ? type?.activeIcon : type?.icon })),
            React.createElement("div", { className: styles.capabilityTitleWrapper },
                index !== undefined && React.createElement("div", { className: styles.agentStepLabel }, `Agent Step ${index + 1}:`),
                React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                    React.createElement("div", { className: styles.capabilityLabel }, type?.label),
                    isAsking && active && (React.createElement("div", null,
                        React.createElement(LoadingIndicator, { style: {
                                width: "20px",
                                height: "18px",
                                transform: "scale(0.35)",
                                margin: "-7px 0px 3px 0px"
                            } })))))),
        React.createElement("div", { className: styles.capabilityDescription }, type?.description),
        isCreateClaw && React.createElement(CreateClawFromChat, null),
        hasMessages && showMessages && (React.createElement("div", { className: styles.agentStepMessages }, stepMessagesArr?.map((message) => {
            return React.createElement(MarkdownTypewriter, { text: message, overrides: CHAT_MARKDOWN_OVERRIDES });
        }))),
        showCharts &&
            (simpleFlowStep === "EXPLORE" ||
                ((chatType === "AIBLE" || chatType === "WHATS_CHANGED") && !isNaN(datasetId))) && (React.createElement("div", { className: styles.capabilityItemChartsContainer },
            React.createElement(ChartsDisplay, { currentViewMessage: currentViewMessage, exploreState: exploreState, updateExploreState: updateExploreState, isAgentSteps: true })))));
};
export default CapabilityItem;
